export default __webpack_public_path__ + "static/media/homebanner.91fa5f60.jpg";